module.exports = __webpack_public_path__ + "img/fordgp.3b93175c.jpg";